import 'css-chunksrc/client/scenes/calendarHolidaysCreation/form/holiday/styles.scss';export default {
  "holidayForm": "_holidayForm_zwwr2_1",
  "holidayRow": "_holidayRow_zwwr2_9",
  "holidayNameInput": "_holidayNameInput_zwwr2_14",
  "dateTimeInput": "_dateTimeInput_zwwr2_19",
  "removeButton": "_removeButton_zwwr2_24",
  "icon": "_icon_zwwr2_33",
  "removeIcon": "_removeIcon_zwwr2_38"
};